import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { rgba } from 'polished';

import {
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_ORANGE,
  COLOR_RED,
  COLOR_GREEN,
  COLOR_DARK_ORANGE,
} from '../../assets/styles/colors';

export const BodyTextSC = styled.p`
  color: ${COLOR_BLACK};
  font-size: 16px;
  margin-bottom: 0;
  display: inline-block;
  &.white {
    color: ${COLOR_WHITE};
  }
  &.grey {
    color: ${rgba(COLOR_WHITE, 0.6)};
  }
  &.dark-grey {
    color: ${rgba(COLOR_WHITE, 0.4)};
  }
  &.orange {
    color: ${COLOR_ORANGE};
  }
  &.dark-orange {
    color: ${COLOR_DARK_ORANGE};
  }
  &.dark-orange-transparent {
    color: ${rgba(COLOR_DARK_ORANGE, 0.3)};
  }
  &.green {
    color: ${COLOR_GREEN};
  }
  &.black-transparent {
    color: ${rgba(COLOR_BLACK, 0.6)};
  }
  &.black-transparent-lighter {
    color: ${rgba(COLOR_BLACK, 0.4)};
  }
  &.black-transparent-lightest {
    color: ${rgba(COLOR_BLACK, 0.2)};
  }
  &.bolder {
    font-weight: 600;
  }
  &.bold {
    font-weight: bold;
  }
  &.red {
    color: ${COLOR_RED};
  }
  &.uppercase {
    text-transform: uppercase;
  }
  &.italic {
    font-style: italic;
  }
  &.block {
    display:block;
  }
`;

const BodyText = (props) => {
  const { children, className, ...rest } = props;
  const customClass = classNames({ [className]: className !== '' });

  return (
    <BodyTextSC className={customClass} {...rest}>
      {children}
    </BodyTextSC>
  );
};

BodyText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

BodyText.defaultProps = {
  className: '',
};

export default BodyText;
